import { CommonModalProps } from "@animech/ui";
import { FunctionComponent, HTMLAttributes, useEffect, useRef } from "react";
import { useTheme } from "@emotion/react";
import * as Styled from "./modal-base.style";
import { isMobile } from "src/utility";

export type ModalBaseProps = CommonModalProps<
	HTMLAttributes<HTMLDivElement>
> & {
	footerButtons: React.ReactElement[] | null;
	title: string;
	icon: React.ReactElement;
	hideCloseButton?: boolean;
};

function useNumericInputMode(ref: React.RefObject<HTMLDivElement>) {
	useEffect(() => {
		if (!isMobile() || !ref.current) {
			return;
		}

		const inputs = Array.from(
			ref.current.querySelectorAll('input[type="number"]'),
		);
		for (const input of inputs) {
			input.setAttribute("inputmode", "numeric");
		}
	});
}

export const ModalBase: FunctionComponent<ModalBaseProps> = (props) => {
	const { children, footerButtons, icon, title, ...baseProps } = props;
	const { maxWidth } = useTheme().app.modals;
	const contentRef = useRef<HTMLDivElement>(null);

	useNumericInputMode(contentRef);

	if (isMobile()) {
		return (
			<Styled.ScreenRoot {...baseProps}>
				<Styled.ScreenContent ref={contentRef}>
					<Styled.CustomScreenHeader>{title}</Styled.CustomScreenHeader>
					{children}
					{footerButtons && (
						<Styled.FooterButtons>{footerButtons}</Styled.FooterButtons>
					)}
				</Styled.ScreenContent>
			</Styled.ScreenRoot>
		);
	}

	return (
		<Styled.ModalRoot
			maxWidth={maxWidth}
			footer={
				footerButtons && (
					<Styled.FooterButtons>{footerButtons}</Styled.FooterButtons>
				)
			}
			{...baseProps}
		>
			<Styled.CustomModalHeader>
				{icon} {title}
			</Styled.CustomModalHeader>

			{children}
		</Styled.ModalRoot>
	);
};
